export const MENU_PAGE_WEEKLY_ACCORDION_ALL_OPEN = 'MENU_PAGE_WEEKLY_ACCORDION_ALL_OPEN';
export const MENU_PAGE_WEEKLY_ACCORDION_ALL_CLOSE = 'MENU_PAGE_WEEKLY_ACCORDION_ALL_CLOSE';